import { createStyles } from '@material-ui/styles'
const styles = ({ breakpoints, bodyFont }) =>
    createStyles({
        faqsContainer: {
            maxWidth: '1062px',
            width: '100%',
            margin: '0 auto',
        },
        faqs: {
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '18px',
            fontWeight: 500,
            // padding: '20px 0',
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                fontSize: '16px',
            },
        },
        hrBorder: {
            border: '1px solid #75A4D3',
        },
        faqContent: {
            fontSize: '16px',
            fontWeight: 400,
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                fontSize: '13px',
            },
        },
        faqSection: {
            margin: '97px 20px',
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
              margin: '38px 20px',
          },
        },
        faqHeader: {
            maxWidth: '800px',
            width: '100%',
            margin: '0 auto',
            textAlign: 'center',
            '& > div:first-child': {
                fontWeight: 600,
                fontSize: '36px',
                marginBottom: '10px',
            },
            '& > div': {
                fontSize: '21px',
                fontWeight: 400,
            },
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                textAlign: 'start',
                '& > div:first-child': {
                    fontSize: '30px',
                    marginBottom: '20px',
                },
                '& > div': {
                    fontSize: '14px',
                },
            },
        },
        faqButtonsContainer: {
            maxWidth: '1100px',
            width: '100%',
            margin: '52px auto 90px',
            display: 'flex',
            justifyContent: 'center',
            gap: '20px',
            flexWrap: 'wrap',
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                justifyContent: 'start',
                margin: '15px auto 38px',
            },
        },
        faqSelectedButton: {
            textTransform: 'none',
            fontFamily: bodyFont,
            backgroundColor: '#75A4D3',
            color: '#FFFFFF',
            fontSize: '18px',
            '&:hover': {
                backgroundColor: '#75A4D3',
            },
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                fontSize: '14px',
            },
        },
        faqButton: {
            textTransform: 'none',
            color: '#75A4D3',
            fontFamily: bodyFont,
            border: '1px solid',
            fontSize: '18px',
            '&:hover': {
                backgroundColor: '#FFFFFF',
            },
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                fontSize: '14px',
            },
        },
    })
export default styles



// WEBPACK FOOTER //
// ./src/components/StartContainer/Faq.style.js